const COUNT_MAX = 999999

export const validateAddBin = ({ partNumber, bin, count, existingBins = [] }) => {
  const trimmedPart = (partNumber || '').trim()
  const trimmedBin = (bin || '').trim()
  const rawCount = (count == null ? '' : String(count)).trim()

  if (!trimmedPart) return { ok: false, error: 'Part # is required.' }
  if (!trimmedBin) return { ok: false, error: 'Bin # is required.' }
  if (!rawCount) return { ok: false, error: 'Count is required.' }
  if (!/^\d+$/.test(rawCount)) return { ok: false, error: 'Count must be a whole number.' }

  const n = Number(rawCount)
  if (n < 1) return { ok: false, error: 'Count must be at least 1.' }
  if (n > COUNT_MAX) return { ok: false, error: `Count must be ${COUNT_MAX.toLocaleString()} or less.` }

  const dupe = existingBins.some(b => (b || '').trim().toUpperCase() === trimmedBin.toUpperCase())
  if (dupe) return { ok: false, error: `Bin "${trimmedBin}" is already on this part.` }

  return { ok: true }
}
